import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import AboutBanner from '../sections/AboutBanner/AboutBanner';
import Faq from '../sections/Faq/Faq';
import Priority from '../sections/Priority/Priority';
import Safety from '../sections/Safety/Safety';
import Team from '../sections/Team/Team';
import Footer from '../sections/Footer/Footer';
import MetaHelmet from '../components/SEO/MetaHelmet';

const About = () => {
    return (
        <>
            <MetaHelmet pageName="about" />
            <Navbar />
            <AboutBanner />
            <Priority />
            <Safety />
            <Team />
            <Faq />
            <Footer />
        </>
    );
};

export default About;